import { useCallback } from 'react';
import { approveHook, revokeHook, deleteHook } from '../../api/hooks';

// The row actions the Hooks page and the course-form section share:
// approve/revoke (replacing the row in `setHooks`) and delete (asking
// first). Failures go to `setError`; `onDeleted` lets the caller reload
// instead of dropping the row locally.
export default function useHookActions({ token, setHooks, setError, onDeleted }) {
    const run = useCallback(async (action) => {
        setError('');
        try {
            await action();
        } catch (err) {
            setError(err.message || 'Something went wrong.');
        }
    }, [setError]);

    const replace = useCallback((updated) => {
        setHooks(prev => prev.map(h => (h.id === updated.id ? updated : h)));
    }, [setHooks]);

    const toggleApproval = useCallback((hook) => run(async () => {
        replace(hook.status === 'approved'
            ? await revokeHook(token, hook.id)
            : await approveHook(token, hook.id));
    }), [run, replace, token]);

    const remove = useCallback((hook) => {
        if (!window.confirm(`Delete this hook?\n\n${hook.question}`)) return;
        run(async () => {
            await deleteHook(token, hook.id);
            if (onDeleted) await onDeleted(hook);
            else setHooks(prev => prev.filter(h => h.id !== hook.id));
        });
    }, [run, token, onDeleted, setHooks]);

    return { run, replace, toggleApproval, remove };
}
